import { faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import moment from "moment";
import Papa from "papaparse";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ServiceContext } from "../../Contexts/ServiceContext";
import { useDidMount } from "../../Hooks/useDidMount";
import { useLoading } from "../../Hooks/useLoading";
import { IProduccionRecord } from "../../Interfaces/IProduccionRecord";
import { GLOBALS } from "../../Models/Globals";
import { ComboSelector } from "../ComboSelector/ComboSelector";
import { HeaderTableCell } from "../Styled/HeaderTableCell";
import { YearFilter } from "../YearFilter/YearFilter";



export const ProduccionReportRender = () => {

    const { SrvContext } = useContext(ServiceContext);
    const [didMount] = useDidMount();
    const { t, i18n } = useTranslation();
    const [isLoading, SetIsLoading] = useLoading();

    const [records, setRecords] = useState<IProduccionRecord[]>([]);
    const [materialOptions, setMaterialOptions] = useState<string[]>([]);
    const [paisesOptions, setPaisesOptions] = useState<string[]>([]);
    const [headers, setHeaders] = useState<string[]>([]);
    const [propsYears, setPropsYears] = useState<string[]>([]);

    const [yearFilter, setYearFilter] = useState<number>(moment().year());
    const [materialFilter, setMaterialFilter] = useState<string>(GLOBALS.NO_SELECTED_OPTION.toString());
    const [paisFilter, setPaisFilter] = useState<string>(GLOBALS.NO_SELECTED_OPTION.toString());
    const [filteredRecords, setFilteredRecords] = useState<IProduccionRecord[]>([]);

    const {
        WindowData
    } = SrvContext;


    const CreateHeaders = (initialYear: number, addYears: number) => {

        const headers = [];
        const yearProps = [];
        console.info("Initial Year", initialYear);
        for (let index = 0; index < addYears; index++) {

            const currentYear = initialYear++;
            headers.push(`${currentYear}`);
            yearProps.push(`a${currentYear}`);

        }

        setHeaders(headers);
        setPropsYears(yearProps);

    };


    const InitializeHeaders = () => {

        CreateHeaders(moment().add(-WindowData.sccoReportsRender.filterYears, "years").year(), WindowData.sccoReportsRender.filterYears);

    };


    const Initialize = async () => {

        InitializeHeaders();
        await i18n.changeLanguage(SrvContext.WindowData.sccoReportsRender.idiomaCode);

    };



    const OnMaterialChange = (option: string) => {

        setMaterialFilter(option);

    };

    const OnPaisesChange = (option: string) => {

        setPaisFilter(option);

    };


    const onYearChanged = (selectedValue: number) => {

        setYearFilter(selectedValue);

    };


    const ReadFileRecords = () => {

        Papa.parse(WindowData.sccoReportsRender.FilePath, {
            download: true,
            header: true,
            complete: results => {
                setRecords(results.data as IProduccionRecord[]);
                setFilteredRecords(results.data as IProduccionRecord[]);
                setMaterialOptions(WindowData.sccoReportsRender.MaterialesFiltro.split(","));
                setPaisesOptions(WindowData.sccoReportsRender.PaisesFiltro.split(","));
                console.info("Parse Response", results.data);
            }

        });


    };


    const createHeaderRow = (material: string, mIndex: number, bgColor: string, fontColor: string) => {

        return (
            <TableRow key={`record-g-data-${mIndex}`} sx={{ backgroundColor: bgColor }}>
                <TableCell align="left" colSpan={headers.length + 2} sx={{ color: `${fontColor}`, fontWeight: "bold" }}>
                    {material}
                </TableCell>
            </TableRow>
        );

    };


    const CheckMaterialRecord = (material: string) => {

        for (let index = 0; index < filteredRecords.length; index++) {
            const element = filteredRecords[index];
            if (element.Material == material) {
                return true;
            }
        }

        return false;

    };

    const CheckPaisRecord = (pais: string) => {

        for (let index = 0; index < filteredRecords.length; index++) {
            const element = filteredRecords[index];
            if (element.Pais == pais) {
                return true;
            }
        }

        return false;

    };


    const formatNumberToShow = (value: any) => {

        if (value) {

            const converted = Number(value);
            return converted != 0 ? converted.toFixed(2) : "-";

        }

        return "-";

    };


    const renderGroupedData = (material: string, mIndex: number) => {

        return (
            <>
                {
                    materialFilter == GLOBALS.NO_SELECTED_OPTION.toString() ? (
                        createHeaderRow(material, mIndex, "#b2b4b2", "black")
                    ) : (
                        <>
                            {
                                materialFilter == material &&
                                createHeaderRow(material, mIndex, "#b2b4b2", "black")
                            }
                        </>
                    )
                }
                {
                    paisesOptions.map((pais, pIndex) => (
                        <>
                            {
                                paisFilter == GLOBALS.NO_SELECTED_OPTION.toString() && CheckMaterialRecord(material) ? (
                                    createHeaderRow(pais, pIndex, "#c1787b", "black")
                                ) : (
                                    paisFilter == pais && CheckPaisRecord(pais) && CheckMaterialRecord(material) &&
                                    createHeaderRow(pais, pIndex, "#c1787b", "black")
                                )
                            }
                            {
                                filteredRecords.map((fRecord, rIndex) => (
                                    fRecord.Material == material && fRecord.Pais == pais &&
                                    <TableRow hover key={`table-row-prod-${rIndex}`}>
                                        <TableCell align="left" sx={{ left: 0, minWidth: "15rem", background: "white" }}>{fRecord.Concepto}</TableCell>
                                        <TableCell align="left" sx={{ left: "15rem", minWidth: "7rem", background: "white" }}>{fRecord.UM}</TableCell>
                                        {
                                            propsYears.map(prop => (
                                                <TableCell align="center">{formatNumberToShow(fRecord[`${prop}`])}</TableCell>
                                            ))
                                        }
                                    </TableRow>
                                ))
                            }
                        </>
                    ))
                }
            </>
        )

    };


    useEffect(() => {

        if (didMount.current) {

            if (yearFilter == GLOBALS.NO_SELECTED_OPTION) {
                InitializeHeaders();
            } else {
                CreateHeaders(yearFilter, 1);
            }

        }

    }, [yearFilter]);

    useEffect(() => {

        if (didMount.current) {

            let toShowRecords = records;

            if (materialFilter != GLOBALS.NO_SELECTED_OPTION.toString()) {

                toShowRecords = toShowRecords.filter(item => {
                    return item.Material == materialFilter;
                });

            }

            if (paisFilter != GLOBALS.NO_SELECTED_OPTION.toString()) {

                toShowRecords = toShowRecords.filter(item => {
                    return item.Pais == paisFilter;
                });
            }

            console.info("to Show", toShowRecords);

            setFilteredRecords(toShowRecords);

        }

    }, [paisFilter, materialFilter]);


    useEffect(() => {

        console.info("Service", SrvContext.WindowData);
        Initialize();
        ReadFileRecords();

    }, []);


    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <ComboSelector
                        Options={materialOptions}
                        LabelKey="material-options"
                        OnSelectionChange={OnMaterialChange}
                        Label={t('label-materiales')}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <ComboSelector
                        Options={paisesOptions}
                        LabelKey="paises-options"
                        OnSelectionChange={OnPaisesChange}
                        Label={t('label-paises')}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <YearFilter
                        OnSelectionChange={onYearChanged}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ paddingTop: "1rem" }}>
                <Grid item xs={4}>
                    <Button variant="contained" fullWidth href={WindowData.sccoReportsRender.FilePath} target="_blank">
                        <Typography variant="body1">
                            <FontAwesomeIcon icon={faFile} /> {t('label-dowload-csv')}
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TableContainer component={Paper} sx={{ maxHeight: "40rem", marginTop: "1rem" }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <HeaderTableCell align="center" sx={{ left: 0, minWidth: "15rem" }}>
                                        {t('label-concepto')}
                                    </HeaderTableCell>
                                    <HeaderTableCell align="center" sx={{ left: "15rem", minWidth: "7rem" }}>
                                        UM
                                    </HeaderTableCell>
                                    {
                                        headers.map((header, index) => (
                                            <HeaderTableCell align="center" key={`current-header-${index}`}>
                                                {header}
                                            </HeaderTableCell>
                                        ))
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    filteredRecords.length == 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={headers.length}>{t('label-no-records')}</TableCell>
                                        </TableRow>
                                    ) : (
                                        <>
                                            {
                                                materialOptions.map((material, index) => (
                                                    renderGroupedData(material, index)
                                                ))
                                            }
                                        </>
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </>
    );

};